(() => {
  class KBHeroSlider {
    constructor(root) {
      if (!root || root.dataset.kbInitialized === 'true') return;
      root.dataset.kbInitialized = 'true';
      this.root = root;
      this.track = root.querySelector('[data-slider-track]');
      this.slides = [...root.querySelectorAll('[data-slide]')];
      this.dots = [...root.querySelectorAll('[data-slider-dot]')];
      this.status = root.querySelector('[data-slider-status]');
      this.index = 0;
      this.timer = null;
      this.dragStart = null;
      this.dragDelta = 0;
      this.autoplay = root.dataset.autoplay === 'true';
      this.loop = root.dataset.loop === 'true';
      this.delay = Math.max(3000, Number(root.dataset.delay) || 6000);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2) return;
      this.bind();
      this.goTo(0, false);
      this.start();
    }
    bind() {
      this.root.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.prev(true));
      this.root.querySelector('[data-slider-next]')?.addEventListener('click', () => this.next(true));
      this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.sliderDot), true)));
      this.root.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') this.prev(true);
        if (e.key === 'ArrowRight') this.next(true);
      });
      if (this.root.dataset.pauseHover === 'true') {
        this.root.addEventListener('mouseenter', () => this.stop());
        this.root.addEventListener('mouseleave', () => this.start());
      }
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', e => { if (!this.root.contains(e.relatedTarget)) this.start(); });
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
      this.root.addEventListener('pointerdown', e => {
        if (e.target.closest('a,button')) return;
        this.dragStart = e.clientX; this.dragDelta = 0; this.stop();
        this.root.classList.add('is-dragging');
        this.root.setPointerCapture?.(e.pointerId);
      });
      this.root.addEventListener('pointermove', e => {
        if (this.dragStart === null) return;
        this.dragDelta = e.clientX - this.dragStart;
        this.track.style.transform = `translate3d(calc(${-this.index * 100}% + ${this.dragDelta}px),0,0)`;
      });
      const endDrag = () => {
        if (this.dragStart === null) return;
        this.root.classList.remove('is-dragging');
        const threshold = Math.min(90, this.root.clientWidth * .12);
        if (this.dragDelta < -threshold) this.next(false);
        else if (this.dragDelta > threshold) this.prev(false);
        else this.goTo(this.index, false);
        this.dragStart = null; this.dragDelta = 0; this.start();
      };
      this.root.addEventListener('pointerup', endDrag);
      this.root.addEventListener('pointercancel', endDrag);
    }
    goTo(nextIndex, interaction = false) {
      if (nextIndex < 0) nextIndex = this.loop ? this.slides.length - 1 : 0;
      if (nextIndex >= this.slides.length) nextIndex = this.loop ? 0 : this.slides.length - 1;
      this.index = nextIndex;
      this.track.style.transform = `translate3d(${-100 * this.index}%,0,0)`;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
      if (this.status && interaction) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (interaction) { this.stop(); this.start(); }
    }
    next(interaction=false) { this.goTo(this.index + 1, interaction); }
    prev(interaction=false) { this.goTo(this.index - 1, interaction); }
    start() {
      this.stop();
      if (!this.autoplay || this.reduceMotion || this.slides.length < 2 || document.hidden) return;
      this.timer = window.setInterval(() => this.next(false), this.delay);
    }
    stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
    destroy() { this.stop(); this.root.dataset.kbInitialized = 'false'; }
  }
  const init = scope => scope.querySelectorAll?.('[data-kb-hero-slider]').forEach(el => new KBHeroSlider(el));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest?.('[data-slide]');
    const root = e.target.closest?.('[data-kb-hero-slider]');
    if (slide && root) {
      const instanceRoot = root;
      const track = instanceRoot.querySelector('[data-slider-track]');
      const slides = [...instanceRoot.querySelectorAll('[data-slide]')];
      const idx = slides.indexOf(slide);
      track.style.transform = `translate3d(${-100 * idx}%,0,0)`;
      slides.forEach((s,i)=>s.setAttribute('aria-hidden',i===idx?'false':'true'));
    }
  });
})();
